import { useTranslation } from "react-i18next";
import { NoDataFound } from "../ui";
import PaymentMethodListItem from "./PaymentMethodListItem";

const PaymentMethodList = ({ data, loading, currentLangId, confirmDeleteHandler, editHandler, apiBaseUrl }) => {
    const [t] = useTranslation('global');
    if (!data || data.length === 0) {
        return (
            <div>
                <div className='text-sm text-slate-500 my-3 px-1'>{t('settings.paymentMethodsList')}</div>
                <div className='p-3 rounded-lg'>
                    <NoDataFound msg={t('settings.noPaymentMethodsFound')} />
                </div>
            </div>
        );
    }

    const list = data.map((item, index) => {
        const relevantDescription = item?.description?.find(desc => desc.lang === currentLangId) ||
            (item?.description?.length > 0 ? item.description[0] : null);
        return (
            <PaymentMethodListItem
                key={item.id}
                item={item}
                description={relevantDescription}
                index={index}
                currentLangId={currentLangId}
                confirmDeleteHandler={confirmDeleteHandler}
                editHandler={editHandler}
                apiBaseUrl={apiBaseUrl}
            />
        );
    });
    return (
        <div>
            <div className='text-sm text-slate-500 my-3 px-1'>{t('settings.paymentMethodsList')}</div>
            <div className='p-3 rounded-lg border border-slate-200'>{list}</div>
        </div>
    );
}

export default PaymentMethodList
